import React from 'react';
import { CaretRight, Check } from 'phosphor-react';
import { Button } from '@material-ui/core';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import {
  openPreapprovedTrueModal,
  openPreapprovedFalseModal,
  openFileUploadModal,
} from '../../../../actions/dashboard';
import { updateProfile } from '../../../../actions/auth';
import styles from '../../../../styles/sass/components/GetPreapproved.module.scss';

export interface Props {
  dispatch: any;
  lenderAlreadyIntroduced: boolean;
  lenderIntroductionComplete: boolean;
  documentUploadComplete: boolean;
  preapproved: string;
  user: any;
  token: string;
  onboarding: any;
}

export const GetPreapproved: React.FC<Props> = ({
  dispatch,
  lenderAlreadyIntroduced,
  lenderIntroductionComplete,
  documentUploadComplete,
  preapproved,
  user,
  token,
  onboarding,
}) => {
  const { preapprovalUploaded, lenderIntroduced } = onboarding;

  // TODO: Remove the checks from dashboard reducer
  React.useEffect(() => {
    if (
      (user.preapprovalUrl && !preapprovalUploaded) ||
      (documentUploadComplete && !user.preapprovalUrl)
    ) {
      dispatch(
        updateProfile(
          { onboarding: { ...user.onboarding, preapprovalUploaded: true } },
          token,
          false,
          true,
        ),
      );
    }
    if (!lenderIntroduced && lenderIntroductionComplete) {
      dispatch(
        updateProfile(
          { onboarding: { ...user.onboarding, lenderIntroduced: true } },
          token,
          false,
          true,
        ),
      );
    }
  }, []);

  const handleStartTask = () =>
    preapproved === 'Yes'
      ? dispatch(openPreapprovedTrueModal())
      : dispatch(openPreapprovedFalseModal());

  // If the user has selected 'Not Preapproved' in the sign-up survey, it means the user has already
  // gone through the preapprovedFalse modal flow
  const handleUploadPreapproval = () => {
    preapproved === 'Yes'
      ? dispatch(openPreapprovedTrueModal())
      : dispatch(openFileUploadModal());
  };

  const renderMedal = () => {
    return preapprovalUploaded || documentUploadComplete ? (
      <div className={`${styles.medal} ${styles.medalCompleted}`}>
        Completed
      </div>
    ) : lenderIntroduced || lenderIntroductionComplete ? (
      <div className={`${styles.medal} ${styles.medalInProgress}`}>
        In-Progress
      </div>
    ) : (
      <div className={`${styles.medal} ${styles.medalCrucial}`}>
        Crucial Task
      </div>
    );
  };

  const renderText = () => {
    const crucialTaskText =
      "In competitive markets, it's important for buyers to be pre-approved so that they can act quickly when they find the right home";

    const lenderIntroCompleteText =
      'Upload your pre-approval below once you have received the final document';

    const text =
      preapprovalUploaded || documentUploadComplete
        ? crucialTaskText
        : lenderIntroduced ||
          lenderIntroductionComplete ||
          lenderAlreadyIntroduced
        ? lenderIntroCompleteText
        : crucialTaskText;

    return <div className={styles.subText}>{text}</div>;
  };

  const renderButton = () => {
    return lenderIntroduced ||
      lenderIntroductionComplete ||
      lenderAlreadyIntroduced ? (
      <Button className={styles.startButton} onClick={handleUploadPreapproval}>
        <div className={styles.text}>Upload pre-approval</div>
        <CaretRight size={28} color="#443461" weight="regular" />
      </Button>
    ) : (
      <Button className={styles.startButton} onClick={handleStartTask}>
        <div className={styles.text}>Start task</div>
        <CaretRight size={28} color="#443461" weight="regular" />
      </Button>
    );
  };
  const currentStatus =
    preapprovalUploaded || documentUploadComplete
      ? 'Document Uploaded'
      : 'Introduction to lender';

  return (
    <div className={styles.mainContainer}>
      <div className={styles.contents}>
        {renderMedal()}
        <div className={styles.heading}>Get pre-approved</div>
        {renderText()}
        {!lenderAlreadyIntroduced &&
          (lenderIntroductionComplete ||
            lenderIntroduced ||
            preapprovalUploaded ||
            documentUploadComplete) && (
            <div className={styles.introCompleteButton}>
              <Check
                size={15}
                color="#04597C"
                weight="regular"
                style={{ marginRight: 2 }}
              />{' '}
              {currentStatus}
            </div>
          )}
        {!preapprovalUploaded && !documentUploadComplete && renderButton()}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  lenderAlreadyIntroduced: state.dashboard.lenderAlreadyIntroduced,
  lenderIntroductionComplete: state.dashboard.lenderIntroductionComplete,
  documentUploadComplete: state.dashboard.documentUploadComplete,
  preapproved: state.signupSurvey.signupSurveyDetails.preapproved,
  token: state.auth.token,
  user: state.auth.user,
  onboarding: state.auth.user.onboarding || {},
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(GetPreapproved);
